<template>
  <div class="iwStore">
    <div class="select">
      <table>
        <tr>
          <td>
            门店ID:
          </td>
          <td>
            <el-input v-model="input2" placeholder="代理ID"></el-input>
          </td>
          <td>
            门店名称:
          </td>
          <td>
            <el-input v-model="input3" placeholder="代理姓名"></el-input>
          </td>
          <td>
            联系电话:
          </td>
          <td>
            <el-input v-model="input4" placeholder="联系电话"></el-input>
          </td>
        </tr>
      </table>
      <div class="selectButton">
        <el-button type="info" style="color: #FFFFFF;">清空</el-button>
        <el-button style="background-color: #FF9000; color: #FFFFFF;">搜索</el-button>
      </div>
    </div>
    <div class="tableData">
      <el-table
        :data="tableData"
        style="width: 100%; text-align: center;"
        height="600"
        :row-style="{height:'30px'}"
        :cell-style="{padding: '5px'}"
        align="center">
        <el-table-column
          prop="storeId"
          label="门店ID"
          width="100"
          align="center">
          <el-button type="text" @click="table = true">0000001</el-button>
        </el-table-column>
        <el-table-column
          prop="storeName"
          label="门店名称"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="level"
          label="门店等级"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="region"
          label="所在地区"
          width="200"
          align="center">
        </el-table-column>
        <el-table-column
          prop="concatName"
          label="联系人姓名"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="category"
          label="门店品类"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="concatPhone"
          label="联系电话"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="bsSubject"
          label="商户主体名称"
          width="150"
          align="center">
        </el-table-column>
        <el-table-column
          prop="bsPhone"
          label="商户联系方式"
          width="150"
          align="center">
        </el-table-column>
        <el-table-column
          prop="reward"
          label="分成状态"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="percent"
          label="分成比例"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="state"
          label="状态"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="operation"
          label="操作"
          width="100"
          align="center">
          <el-button type="text" @click="dialogTableVisible1 = true">编辑</el-button>
        </el-table-column>
      </el-table>
      <div>
        <el-dialog title="收货地址" :visible.sync="dialogFormVisible1">
          123
          <!--          <el-form :model="form">-->
          <!--            <el-form-item label="活动名称" :label-width="formLabelWidth">-->
          <!--              <el-input v-model="form.name" autocomplete="off"></el-input>-->
          <!--            </el-form-item>-->
          <!--            <el-form-item label="活动区域" :label-width="formLabelWidth">-->
          <!--              <el-select v-model="form.region" placeholder="请选择活动区域">-->
          <!--                <el-option label="区域一" value="shanghai"></el-option>-->
          <!--                <el-option label="区域二" value="beijing"></el-option>-->
          <!--              </el-select>-->
          <!--            </el-form-item>-->
          <!--          </el-form>-->
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible1 = false">取 消</el-button>
            <el-button type="primary" @click="dialogFormVisible1 = false">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage3"
          :page-size="100"
          layout="total, prev, pager, next, jumper"
          :total="1000">
        </el-pagination>
      </div>
    </div>
    <div class="detail">
      <el-drawer
        :visible.sync="table"
        :with-header="false"
        direction="rtl"
        show-close="true"
        size="50%">
        <div class="title">
          <div class="titleImg">
            <img :src="titleImg" width="100%" height="100%" alt=""/>
          </div>
          <div class="orderId">
            <span>代理ID：0000001</span>
          </div>
        </div>
        <div class="tag">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="基本信息" name="first">
              <table>
                <th>
                  基本信息
                </th>
                <tr style="height: 50px;">
                  <td style="width: 200px;">商户主体名称</td>
                  <td style="width: 300px;">无忧酒吧</td>
                  <td style="width: 200px;">商户联系人姓名</td>
                  <td style="width: 300px;">何静</td>
                </tr>
                <tr style="height: 50px;">
                  <td>分成状态</td>
                  <td>参与</td>
                  <td>商户联系方式</td>
                  <td>13981290007</td>
                </tr>
                <tr style="height: 50px;">
                  <td>商户联系方式</td>
                  <td>13981290007</td>
                  <td>门店详细地址</td>
                  <td>滨河北路127号</td>
                </tr>
                <tr style="height: 50px;">
                  <td>是否连锁店</td>
                  <td>否</td>
                  <td>营业时间</td>
                  <td>08:00-21:29</td>
                </tr>
                <tr style="height: 50px;">
                  <td>代理姓名</td>
                  <td>何鑫</td>
                  <td>代理电话</td>
                  <td>18882003333</td>
                </tr>
                <tr style="height: 50px;">
                  <td>门店单价</td>
                  <td>1.50元/半小时</td>
                  <td>人均消费</td>
                  <td>2.00</td>
                </tr>
                <tr style="height: 50px;">
                  <td>门头照</td>
                  <td></td>
                </tr>
              </table>
            </el-tab-pane>
            <el-tab-pane label="历史信息" name="second">
              <div class="orderInfo">
                <el-table
                  :data="tableData"
                  style="width: 100%"
                  height="600"
                  :row-style="{height:'40px'}"
                  :cell-style="{padding: '10px'}">
                  <el-table-column
                    prop="time"
                    label="创建时间"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="type"
                    label="类型"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="operationPerson"
                    label="商户ID"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="operationPhone"
                    label="联系人姓名"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="operationPhone"
                    label="商户主体名称"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="operationPhone"
                    label="商户联系方式"
                    width="150">
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane label="流转信息" name="third">
              <el-table
                :data="tableData"
                style="width: 100%"
                height="600"
                :row-style="{height:'40px'}"
                :cell-style="{padding: '10px'}">
                <el-table-column
                  prop="storeId"
                  label="创建时间"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="storeName"
                  label="类型"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="storePerson"
                  label="操作人类型"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="storePhone"
                  label="操作人"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="storeState"
                  label="操作人联系方式"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="storeState"
                  label="备注"
                  width="150">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="设备列表" name="fourth">
              <el-table
                :data="tableData1"
                style="width: 100%">
                <el-table-column
                  prop="bdId"
                  label="设备编号"
                  sortable
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="bdName"
                  label="设备类型"
                  sortable
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="position"
                  label="设备持有人">
                </el-table-column>
                <el-table-column
                  prop="position"
                  label="设备状态">
                </el-table-column>
                <el-table-column
                  prop="bdPhone"
                  label="设备部署时间">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="订单列表" name="five">
              <el-table
                :data="tableData"
                style="width: 100%">
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                      <el-form-item label="租借时长">
                        <span>06时13分58秒</span>
                      </el-form-item>
                      <el-form-item label="商户">
                        <span>宋建军</span>
                      </el-form-item>
                      <el-form-item label="代理">
                        <span>皓乐广元</span>
                      </el-form-item>
                      <el-form-item label="订单状态">
                        <span>已完成</span>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column
                  label="订单号"
                  prop="orderId">
                </el-table-column>
                <el-table-column
                  label="订单金额"
                  prop="name">
                </el-table-column>
                <el-table-column
                  label="代理分成"
                  prop="desc">
                </el-table-column>
                <el-table-column
                  label="商户分成"
                  prop="desc">
                </el-table-column>
                <el-table-column
                  label="门店分成"
                  prop="desc">
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IwStore',
  data() {
    return {
      titleImg: require('../../../static/image/powerbankorder/bianji.png'),
      handleSizeChange: '',
      handleCurrentChange: '',
      currentPage3: '',
      input1: '',
      input2: '',
      input3: '',
      input4: '',
      input5: '',
      input6: '',
      input7: '',
      activeName: 'first',
      tableData: [{
        orderId: <a href="">00000001</a>
      },
        {
          orderId: <a href="">00000001</a>
        },
        {
          orderId: <a href="">00000001</a>
        },
        {
          orderId: <a href="">00000001</a>
        },
        {
          orderId: <a href="">00000001</a>
        },
        {
          orderId: <a href="">00000001</a>
        },
        {
          orderId: <a href="">00000001</a>
        },
        {
          orderId: <a href="">00000001</a>
        },
        {
          orderId: <a href="">00000001</a>
        },
        {
          orderId: <a href="">00000001</a>
        }],
      table: false,
      tableData1: [{
        id: 1,
        bdId: 'HYSC092007000495',
        bdName: '',
        position: '',
        bdPhone: ''
      }],
      dialogFormVisible1: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      formLabelWidth: '120px'
    }
  }
}
</script>
<style scoped>
body {
  margin: 0px;
}

.iwStore {
  margin: 0px 0px 0px 0px;
  background-color: #f2f2f2;
  width: 1630px;
  height: 750px;
}

.select {
  width: 97%;
  height: 80px;
  margin-left: 50px;
  background-color: #FFFFFF;
}

.select table {
  float: left;
  width: 60%;
  margin: 10px 10px;
  text-align: left;
}

.selectButton {
  width: 200px;
  margin-top: 20px;
  float: right;
}

table tr {
  height: 50px;
}

.select .el-button {
  display: block;
  float: right;
}

.tableData {
  margin-top: 20px;
  margin-left: 50px;
}

a {
  color: #FF9000;
}

.block {
  margin-top: 50px;
}

.el-button {
  margin-left: 10px;
}

.el-table .el-button {
  color: #FF9000;
}

.title {
  height: 60px;
  background-color: #FF9000;
}

.titleImg {
  width: 40px;
  height: 40px;
}

.titleImg img {
  display: block;
  float: left;
  margin: 10px 20px;
}

.orderId {
  float: left;
  margin-top: -20px;
  margin-left: -10px;
}

.title .el-button {
  background-color: red;
  border-radius: 10px;
  float: right;
  margin-top: -25px;
  margin-right: 20px;
}

.orderDetail table {
  display: block;
  text-align: left;
  float: left;
  margin-top: 10px;
  margin-left: -170px;
  font-size: 16px;
}

.tag table {
  text-align: left;
  margin-left: 50px;
}

.tag span {
  margin-left: -800px;
}

.orderInfo {
  width: 100%;
  height: 250px;
  margin: 0px auto -20px;
}

/deep/ :focus {
  outline: 0;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/storemanagement/iwstore.vue